/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, RefObject, useContext } from 'react'

// workaround for flickity ref not initialized
export type ProductCarouselContextType = {
  flickityRef: any
  thumblistRef?: RefObject<HTMLDivElement>
  isFlickityActive: boolean
  setFlickityActive: (init: boolean) => void
}

export const ProductCarouselContext = createContext<ProductCarouselContextType>({
  flickityRef: null,
  isFlickityActive: false,
  setFlickityActive: () => { },
})

export const useProductCarouselContext = () => {
  const context = useContext(ProductCarouselContext)

  if (context === undefined) {
    throw new Error(
      'useProductCarouselContext must be used within a ProductCarouselContext.Provider',
    )
  }

  return context
}
